/* tslint:disable */

/**
 */
export class ShiftDestroyAccept {
    id?: number;
    type?: string;
}
